import type {
  Page,
  PDFMergeFunction,
  PDFRasterizeFunction,
  PDFSplitFunction,
  PlottingContext,
} from "@pdfking/renderer-api"

type ProxyModule = typeof import("../utils/Proxy")

const proxy = <T>(fn: (m: ProxyModule) => Promise<T>): Promise<T> =>
  import("../utils/Proxy").then(fn)

export const ImageToPdf = (
  blob: Blob,
  image_resolution: number
): Promise<Blob> =>
  proxy(({ ImageToPdf }) => ImageToPdf(blob, image_resolution))

export const PlotPage = (
  page: Page,
  partial: PlottingContext = {}
): Promise<Blob> => proxy(({ PlotPage }) => PlotPage(page, partial))

export const PDFMerge: PDFMergeFunction = async function* (pages) {
  const { PDFMerge } = await import("../utils/Proxy")
  yield* PDFMerge(pages)
}

export const PDFRasterize: PDFRasterizeFunction = async function* (
  input,
  image_resolution,
  rangeFn
) {
  const { PDFRasterize } = await import("../utils/Proxy")
  yield* PDFRasterize(input, image_resolution, rangeFn)
}

export const PDFSplit: PDFSplitFunction = async function* (input, rangeFn) {
  const { PDFSplit } = await import("../utils/Proxy")
  yield* PDFSplit(input, rangeFn)
}
